export default __webpack_public_path__ + "media/images/corporate/hero/sm-5fe6c7056e73ed4b8177769a7ea2b41c.png";